// extracted by mini-css-extract-plugin
module.exports = {"out-of-stock":"out-of-stock_out-of-stock__B4kZ5"};